import React from 'react';
import './ContractButton.scss';

export interface UHCContractButtonProps {
    onClick:React.MouseEventHandler<HTMLButtonElement>
}

const UHCContractButton: React.FC<UHCContractButtonProps> = (props:UHCContractButtonProps) =>{
    return (
        <button data-testid='sidebar-contract-button' onClick={(e) => (props.onClick) ? props.onClick(e) : null} className="sidebar-contract-button">Contratar</button>
    )
}

export default UHCContractButton;